import { Control, Controller } from 'react-hook-form';
import { CreateProductFormSchemaType, LANG_LIST } from '../common';
import { FormLabel } from '../form-label';
import i18n from 'i18n';
import LOCALS from 'commons/locals';
import classNames from 'classnames';
import { Input, Tag } from 'antd';
import { useAppSelector } from 'store/hooks';
import { selectGlobalInfo } from 'store/slices/globalInfoSlice';

const ProductSize = ({
  control,
}: {
  control: Control<CreateProductFormSchemaType>;
}) => {
  const { language } = useAppSelector(selectGlobalInfo);

  return (
    <div className="flex gap-2">
      <FormLabel className="basis-[12.5%]">
        {i18n.t(LOCALS.measurement)}:
      </FormLabel>

      <div className="relative w-full">
        <div className="items-center w-full grid grid-cols-2 gap-y-3 gap-x-8 bg-gray-200 p-3 rounded-md">
          {LANG_LIST.map((lang) => {
            return (
              <div key={lang} className="flex gap-1">
                <Tag
                  color={lang === language ? '#1677ff' : 'default'}
                  className={classNames(
                    'flex items-center justify-center mx-0',
                    language === 'en' ? 'w-40' : 'w-[120px]'
                  )}
                >
                  {i18n.t(lang)}
                </Tag>

                <Controller
                  name={`size.${lang}`}
                  control={control}
                  render={({ field }) => {
                    return (
                      <Input.TextArea
                        {...field}
                        placeholder={i18n.t(LOCALS.please_enter) || ''}
                      />
                    );
                  }}
                ></Controller>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ProductSize;
